import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useContext, useMemo } from "react";
import { customTheme } from "../../../../../config/theme/MuiTheme";
import { setSnackbar } from "../../../../../util/state/globalAction";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../../util/state/globalVariables";
import { SupplierCustomGroupService } from "../service/supplierCustomGroupLocations.actions";
import GroupLocationsTypes from "../Types";
import { useTranslation } from "react-i18next";
import EnumChangeName from "../../common/EnumChangeName";

export type GroupLocationsType = "groupLocations" | "location";

interface Props {
  tenant: string;
  isOpen: boolean;
  onClose: () => void;
  deleteType: GroupLocationsType;
  groupLocations?: GroupLocationsTypes.GroupLocations;
  location?: GroupLocationsTypes.ILocationsValid;
  onUpdateDatasource?: any;
}

const DeleteConfirmation = (props: Props) => {
  const { dispatchGlobalData } = useContext(GlobalContext);
  const { t } = useTranslation(["operation"]);

  const changeTypeShow = EnumChangeName();

  const onDeleteGroupLocations = () => {
    if (props.groupLocations) {
      SupplierCustomGroupService.delete
        .groupLocation(props.tenant, props.groupLocations.id)
        .then(
          () => {
            props.onClose();

            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                snackbar: {
                  message: t(
                    "supplierCustomGroupLocation.deleteModal.succesfull"
                  ),
                  type: snackbarTypes.success,
                  show: true,
                  autoClose: true,
                },
              },
            });

            props.onUpdateDatasource && props.onUpdateDatasource();
          },
          () => {
            props.onClose();

            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                snackbar: {
                  message: t(
                    "supplierCustomGroupLocation.deleteModal.errorGroup"
                  ),
                  type: snackbarTypes.error,
                  show: true,
                  autoClose: true,
                },
              },
            });
          }
        );
    }
  };

  const onDeleteLocation = () => {
    if (props.location && props.groupLocations) {
      const updateData = {
        locationCustomGroupMessage: {
          id: props.groupLocations?.id,
          name: props.groupLocations?.name,
          desc: props.groupLocations?.desc,
          locations: props.groupLocations?.locations.filter(
            (loc: any) => loc.id !== props?.location?.id
          ),
        },
      };

      SupplierCustomGroupService.update
        .groupLocations(
          props.tenant,
          props.groupLocations.id,
          updateData as any
        )
        .then(
          (response: any) => {
            props.onClose();
            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                snackbar: {
                  message: t(
                    "supplierCustomGroupLocation.deleteModal.removeLocation"
                  ),
                  type: snackbarTypes.success,
                  show: true,
                  autoClose: true,
                },
              },
            });

            props.onUpdateDatasource && props.onUpdateDatasource(response);
          },
          () => {
            props.onClose();

            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                snackbar: {
                  message: t(
                    "supplierCustomGroupLocation.deleteModal.errorRemove"
                  ),
                  type: snackbarTypes.error,
                  show: true,
                  autoClose: true,
                },
              },
            });
          }
        );
    }
  };

  const onDelete = () => {
    if (props.deleteType === "groupLocations") {
      onDeleteGroupLocations();
    }

    if (props.deleteType === "location") {
      onDeleteLocation();
    }
  };

  const textMessage = useMemo(() => {
    if (props.deleteType === "location") {
      return `"${props.location?.locationDesc} - ${changeTypeShow.locationType(
        props.location?.locationType!
      )}"`;
    }

    if (props.deleteType === "groupLocations") {
      return `"${props.groupLocations?.name} - ${props.groupLocations?.desc}"`;
    }
  }, [props.location, props.groupLocations, props.deleteType]);
  return (
    <Mui.Dialog open={props.isOpen} onClose={props.onClose}>
      <Mui.DialogTitle>
        <Mui.Grid container columnSpacing={1}>
          <Mui.Grid item xs="auto" color={customTheme.palette.accent.main}>
            <MuiIcons.Info color="inherit" />
          </Mui.Grid>

          <Mui.Grid item xs="auto">
            <Mui.Typography variant="h5">
              {t("supplierCustomGroupLocation.deleteModal.title")}
            </Mui.Typography>
          </Mui.Grid>

          <Mui.Grid item xs="auto" marginLeft="auto">
            <Mui.IconButton onClick={props.onClose}>
              <MuiIcons.Close />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>

      <Mui.DialogContent>
        <Mui.Typography
          variant="bodySmall"
          color="#18305B"
          style={{ whiteSpace: "pre-line" }}
        >
          {t("supplierCustomGroupLocation.deleteModal.description").replace(
            "#textElement",
            textMessage || ""
          )}
        </Mui.Typography>
      </Mui.DialogContent>

      <Mui.DialogActions>
        <Mui.Button variant="outlined" onClick={props.onClose}>
          {t("supplierCustomGroupLocation.deleteModal.actions.cancel")}
        </Mui.Button>

        <Mui.Button variant="contained" onClick={onDelete}>
          {t("supplierCustomGroupLocation.deleteModal.actions.deleteLocation")}
        </Mui.Button>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};

export default DeleteConfirmation;
